export const SET_ROLE = "ROLES/SET_ROLE";
export const SET_ROLES = "ROLES/SET_ROLES";
export const SET_ROLE_PERMISSIONS = "ROLES/SET_ROLE_PERMISSIONS";
export const SET_PAGINATION = "ROLES/SET_PAGINATION";

export const SET_PERMISSIONS = "PERMISSIONS/SET_PERMISSIONS";

